import React, { useEffect, useState, useContext } from "react";

import 'react-phone-number-input/style.css';
import { AppContext, UserContext } from "../../../AppContextProvider";
import {ButtonLoader} from "../../utils/ButtonLoader";
import { isMobile } from "react-device-detect";
import InscriptionForm from "./Registration";
import {useNavigate, useParams } from "react-router-dom";
import Login from "./Login";
import { useTranslation } from "react-i18next";
import { useFetch } from "../../api/FetchApiData";
import CG from "../../cgu/CG";

if (isMobile)
    import('./authentification_mob.css').then(() => {});
else
    import('./authentification.css').then(() => {});


function ActivationFailForm({user_id,setNotification,setConFormIsSelected})
{
    const [activation_code,setCode] = useState({'code_1':0,'code_2':0,'code_3':0,'code_4':0});
    const fetchData = useFetch();
    const {t} = useTranslation();
    const [loading,setLoading] = useState(false);
    const [_user_id,setUserId] = useState(user_id);

    useEffect(()=>{setUserId(user_id)},[user_id]);

    const ActivateAccount = ()=>{
        /*
        if(_user_id===null)
            return
        */
        let act_code = activation_code.code_1.toString() + activation_code.code_2.toString() + activation_code.code_3.toString() + activation_code.code_4.toString();
        /*
        activation_code.forEach(element => {
            act_code = act_code + element.toString();
        });*/
        const data_ = {user_id:_user_id,account_activation_code:act_code}
        fetchData.PostData(data_,'user/register/').then((result)=>{
            setLoading(false);
            if(result.result)
            {
                setNotification({"origine":'activation',"value":result.notification});
                setUserId(result.user_id);
                setConFormIsSelected(1);
            }
            else
            {setNotification({"origine":'activation',"value":result.notification});
            //setConFormIsSelected(3);
            }
    });}

    const GetActivationCode = ()=>{
        const data_ = {user_id:_user_id,'get_activation_code':true}
        fetchData.PostData(data_,'user/register/').then((result)=>{
            setLoading(false);
            if(result.result)
            {
                setNotification({"origine":'activation',"value":result.notification});
                //setUserId(result.user_id);
                //setConFormIsSelected(1);
            }
            else
            {setNotification({"origine":'activation',"value":result.notification});
            //setConFormIsSelected(3);
            }
    });
    }

        return(
        <div className="Form">
            <div style={{width:'100%',margin:'auto',marginTop:'10px'}}>
                <div style={{width:'100%',margin:'auto',textAlign:'center'}}>
                    <h3 style={{}}><b>{t('authentication.code-activation-title')}</b></h3>
                    <div className="div-code-input">
                        <input onChange={(e)=>{setCode({...activation_code, 'code_1':e.target.value});}} type="number" onClick={e=>{}} name="code_1" placeholder="0" className="code-input" min={0} max={9} />
                        <input onChange={(e)=>{setCode({...activation_code, 'code_2':e.target.value});}} type="number" name="code_2" placeholder="0" className="code-input" min={0} max={9} />
                        <input onChange={(e)=>{setCode({...activation_code, 'code_3':e.target.value});}} type="number" name="code_3" placeholder="0" className="code-input" min={0} max={9} />
                        <input onChange={(e)=>{setCode({...activation_code, 'code_4':e.target.value});}} type="number" name="code_4" placeholder="0" className="code-input" min={0} max={9} />
                    </div>
                    <div className="btnSubmit">
                        <ButtonLoader loading={loading} onSubmit={e=>{ActivateAccount()}} style={{backGroundColor:'lightgreen',fontSize:'small'}}  text={t("authentication.valider")} />
                    </div>
                    <div className="btnSubmit">
                        <ButtonLoader loading={loading} onSubmit={e=>{GetActivationCode()}} style={{backGroundColor:'lightgray',fontSize:'small'}}  text={t("renvoyer-email")} />
                    </div>
                </div>
            </div>
        </div>
        );
}

function PassWordForm({setConFormIsSelected=()=>{},setTopForm=()=>{}})
{
    const [email,setEmail] = useState(null);
    const fetchData = useFetch();
    const [loading,setLoading] = useState(false);
    const {t} = useTranslation();
    const [AppState,setAppState] = useContext(AppContext);
    const [notif,setNotif] = useState({title:"",text:"",titlecolor:"black",textcolor:"darkgray"});
    let fontsize = 'medium';
    if(isMobile)
        fontsize = 'x-small';

    useEffect(()=>{
            setNotif({
                title:t('authentication.mot-de-passe-oublie'),
                titlecolor:'black',
                textcolor:'darkgray',
                text:t('authentication.mot-de-passe-oublie-text')
            });
        //}
    },[]);

    const AskNewPassWord =()=>
    {
        const data = {'new_password':true,'email':email};
        setLoading(true);
        fetchData.PostData(data,'user/register/').then((result)=>{
            if(result.result)
            {
                setNotif({
                title:'Mot de passe oublié',
                titlecolor:'black',
                textcolor:'green',
                text:result.notification});
            }
            else
            {
                setNotif({
                    title:'Mot de passe oublié',
                    titlecolor:'black',
                    textcolor:'orange',
                    text:result.notification});
            }
            setLoading(false);
        })
    }

    return(
        <div className="Form">
            <p style={{color:notif.textcolor,marginTop:'0px',width:'60%',fontSize:fontsize,position:'relative',left:'20%'}}>
                <span style={{color:notif.titlecolor,paddingBottom:'20px',fontSize:'small'}}><b>{notif.title}</b></span><br/>
                <span style={{fontSize:'x-small',lineHeight:'0px'}}>{notif.text}</span>
            </p>
            <div className="inputDiv" style={{display:'flex',flexDirection:(AppState.settings.lang==='ar')?'row-reverse':'row'}}>
                <label style={{width:'20%'}}>{t('authentication.email')}</label>
                <input style={{width:'60%',fontSize:'x-small'}} onChange={e=>{setEmail(e.target.value)}} type="email" name="email" placeholder={t('authentication.email')} />
            </div>
            <div style={{width:'100%',margin:'auto',marginTop:'10px'}}>
                <div className="btnSubmit">
                    <ButtonLoader loading={loading} onSubmit={e=>{AskNewPassWord()}} style={{backGroundColor:'lightblue',fontSize:'x-small'}}  text={t('authentication.envoyer')} />
                </div>
                <input onClick={e=>{setConFormIsSelected(1);setTopForm('50%');}} type="button" className="btnSubmit" style={{backgroundColor:'lightgray',fontSize:'x-small'}} value={t('authentication.connexion')}></input>
            </div>
        </div>
    );
    //}
}


export default function Authentification({ConForm=1})
{  
    const [ConFormIsSelected,setConFormIsSelected] = useState(ConForm);
    const [notification,setNotification] = useState({"origine":"","value":""});
    const [loading,setLoading] = useState(false);
    const params = useParams();
    const [topform,setTopForm] = useState('50%');
    const [UserState, setUserState] = useContext(UserContext);
    const navigator = useNavigate();
    const {t} = useTranslation();
    const [error_user_id,setErrorUserId] = useState(null);


    useEffect(()=>{
        //setNotification({"origine":'inscription',"value":"success"});
        if(isMobile)
            setTopForm("0%");
        if(params.hasOwnProperty("result") && (params.result === 'success' || params.result === 'failed') && !isMobile)
        {
            setNotification({origine:'activation',value:params.result});setTopForm('50%'); 
        }
        if(params.hasOwnProperty("initpwd") && !isMobile)
            setTopForm('30%');
        if(params.hasOwnProperty("result") && (params.result === 'success' || params.result === 'failed') && isMobile)
        {
            setNotification({origine:'activation',value:params.result});setTopForm('50%'); 
        }
        if(params.hasOwnProperty("initpwd") && isMobile)
            setTopForm('30%');
        
    },[]);

    useEffect(()=>{
        if(UserState.auth)
            navigator('/user/');
    },[])

    const notify=()=>
    {
        let spanColor = "";
        let spanText = "";
        let text = "";
        switch(notification['origine'])
        {
            case 'inscription':
                if(notification['value']==="fail")
                {   
                    spanColor = "orangered";
                    spanText = "Nous rencontrons des problèmes en ce moment.";
                    text = "Veuillez s'il vous plait reessayer plus tard.";
                }
                else if(notification['value']==="exist")
                {
                    spanColor = "orangered";
                    spanText = "";
                    text = "Un compte avec l'adresse que vous avez founi existe déjà. Veuillez vous connecter.";
                }
                else if(notification['value']==="success")
                {
                    spanColor = "green";
                    spanText = "Inscription reussie : ";
                    text = "Votre compte a bien été crée. Pour valider votre adresse mail, veuillez indiquer le code envoyé par mail. Toute l'équipe de notre plateforme vous remercie.";
                }
                else if(notification['value']==="network")
                {
                    spanColor = "red";
                    spanText = "Problème d'accès à internet.";
                    text = ""; 
                }
                break;
            case 'password':
                if(notification['value']==="incorrect")
                {
                    spanColor = "red";
                    spanText = "Mot de passe invalide";
                    text = "Votre mot de passe doit contenir au moins 8 caractères, au moins un majiscule, un moins un miniscule";
                }
                break;
            case 'login':
                if(notification['value']==="not-found")
                {
                    spanColor = "orangered";
                    spanText = "Compte introuvable.";
                    text = "Verifiez que votre adresse mail est correct";  
                }
                else if(notification['value']==="wrong-password")
                {
                    spanColor = "red";
                    spanText = "Mot de passe incorrect.";
                    text = ""; 
                }
                else if(notification['value']==="network")
                    {
                        spanColor = "red";
                        spanText = "Problème d'accès à internet.";
                        text = ""; 
                    }
                else
                {
                        spanColor = "";
                        spanText = "";
                        text = ""; 
                }
                break;
            case 'email':
                spanColor = "orangered";
                spanText = "Email invalide";
                text = "";
                break;
            case 'activation':
                if(params.hasOwnProperty("result") && params.result === 'success')
                {
                    spanColor = "green";
                    spanText = "Email Validé";
                    text = "Votre compte a été créé avec succès. vous pouvez desormais vous connectez et effectuer vos achats. Toute l'équipe de notre plateforme vous remercie. ";
                }
                else if(params.hasOwnProperty("result") && params.result === 'failed')
                {
                    spanColor = "orangered";
                    spanText = "Email non Validé";
                    text = "Veuillez nous excuser, nous avons pas pu valider votre adresse mail. Vous pouvez renvoyer un mail de validation en cliquant sur le boutton ci-dessous.";
                }
                else
                {
                    spanColor = "green";
                    spanText = "Email Envoyé";
                    text = "Un mail a été envoyé à votre addresse email avec le code d'activation de votre compte";
                }
                break;
            default:
                {
                    spanColor = "black";
                    spanText = t("authentication.authentification");
                    text = t("authentication.login-text");
                }
                break;    
        }
        let fontsize = 'x-small';
        if(!isMobile)
            fontsize = 'small';
        return(
            <div className="autentification-nofification">
                <p style={{color:spanColor,width:'60%',fontSize:fontsize,position:'relative',left:'20%',display:'block'}}>
                    <span style={{color:spanColor,paddBottom:'20px'}}><b>{spanText}</b></span><br />
                    {text}    
                </p>
            </div>
        );
    }

    useEffect(()=>{
        if(ConFormIsSelected===1)
            setTopForm('50%');
        else if(ConFormIsSelected===2)
            setTopForm('30%');
        else
            setTopForm('52%');
    },[ConFormIsSelected])



    const ShowForm = ()=>
    {
        
        if(ConFormIsSelected===3 || (params.hasOwnProperty("result") && params.result === 'failed'))
            return <ActivationFailForm user_id={error_user_id} setNotification={setNotification} setConFormIsSelected={setConFormIsSelected} loading={loading} />;
        else if(ConFormIsSelected===2)
            return <PassWordForm setConFormIsSelected={setConFormIsSelected} setTopForm={setTopForm} />;
        else if(ConFormIsSelected===1 || (params.hasOwnProperty("result") && params.result === 'success'))
             return <Login Login={Login} setUserId={setErrorUserId} setNotification={setNotification} setConFormIsSelected={setConFormIsSelected} />;
        else
            return <InscriptionForm setUserId={setErrorUserId} setNotification={setNotification} setConFormIsSelected={setConFormIsSelected} />; 
    
    }

    const formatText=()=>
    {
        const text = "ljspjkf ojfsdp fokpfod jofjo ihisdfi jsfj ojosf djj o fjiodjsiof jsdojo oosdj fojdojfo sdjoj sdfjosd jfojoj ojsdojo jdojo jsdojosdfno fjo jofjdojofjdojfjosdjfo ojodsjfoj iosjfo jsdfjiosd ofjsdoj sfjosd jojojfosdjojo jsdojfosd ojosdj ojsdo jfsodjfo jsdojod sojfod sojfoj sfjdo jjfdosjofjdojfodjofjsojfojsdojfiosdjo ojsiodjfo osjfo ojosd fojos do osdp o pksdpfkp kpp kpfkp pp pk fohso spdjpo fso jsodj ojosjd oojo sfdoi ojso j osdjo os jojosdfjo o josdj ojosdf o josdf jo jsdfo oo osdjo sdofjo ojsdoj iojsdffiojoj osdjfiojiosdfjojo jsdfojo odfjso josdf jsdfoj  ojsdojosdff jfdio ojsd fojo dfjsoj osdfojoi jsdofojiofjsdio sjfio jsjdfo po jijisd hiuiuhs uidfhijiodfsijio oiojsdfo ohiush iuihih sdf sofjdoj dosjf oj ofjiojio jiojdos i jojioj odfjojodjiojo jojdfoj ojo fdoj osdf jo jiodf jojsdfo j o jofjdojofjdojfjosdjfo josdjf ojosfjo ojofdjjosd fjojio sdfojo sdfojio jiodfjojsdofjiduihuih ih sifhuihdsif huisd hiosdfjoihi nfsd ojhsdfoi ojofjo jofjiojoj iosd jiojsdio jiojfiosjpojsdiojiosdhishdfuihfidsj ojoisdfjiodjfioj";
       return text;
    }
    
    return(
        <div id="auth">
            <fieldset >
                {notify()}
                {ShowForm()}
            </fieldset>
        </div>
    );
}